export default {
  path: '/development',
  component: () => import('views/Layout.vue'),
  children: [
    {
      path: 'PolicyManagement',
      name: 'PolicyManagement',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '策略管理',
        keepAlive: true,
        defaultComponent: () => import('views/singleSiteMonitor/policyManagement/index.vue'),
      },
    },
    {
      path: 'DeviceDevelopment',
      name: 'DeviceDevelopment',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '微网调试',
        keepAlive: true,
        defaultComponent: () => import('views/singleSiteMonitor/deviceDevelopment/index.vue'),
      },
    },
    {
      path: 'DeviceCheck',
      name: 'DeviceCheck',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '设备自检',
        keepAlive: true,
        defaultComponent: () => import('views/singleSiteMonitor/deviceCheck/index.vue'),
      },
    },
    {
      path: 'standardModel',
      name: 'standardModel',
      redirect: '/development/standardModel/standardModellist',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '标准模型管理',
        // keepAlive: true,
        withoutPermission: true,
        defaultComponent: () => import(/*webpackChunkName: "physicalModelManagement"*/ 'views/system/models/standardModel/index'),
      },
      children: [
        {
          path: 'standardModellist',
          name: 'standardModellist',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '标准模型管理',
            withoutPermission: true,
            // keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "physicalModelManagement"*/ 'views/system/models/standardModel/list'),
          },
        },
        {
          path: 'standardModeladd',
          name: 'standardModeladd',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '标准模型管理',
            withoutPermission: true,
            // keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "physicalModelManagement"*/ 'views/system/models/standardModel/add'),
          },
        },
      ],
    },
    {
      path: 'physicalModel',
      name: 'physicalModel',
      redirect: '/development/physicalModel/physicalModellist',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '物模型管理',
        // keepAlive: true,
        withoutPermission: true,
        defaultComponent: () => import(/*webpackChunkName: "physicalModelManagement"*/ 'views/system/models/physicalModel/index'),
      },
      children: [
        {
          path: 'physicalModellist',
          name: 'physicalModellist',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '物模型管理',
            withoutPermission: true,
            // keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "physicalModelManagement"*/ 'views/system/models/physicalModel/list'),
          },
        },
        {
          path: 'physicalModeladd',
          name: 'physicalModeladd',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '物模型管理',
            // keepAlive: true,
            withoutPermission: true,
            defaultComponent: () => import(/*webpackChunkName: "physicalModelManagement"*/ 'views/system/models/physicalModel/add'),
          },
        },
      ],
    },
  ],
}
